import { aMapper } from "./a-mapper/a.mapper";
import { codeMapper } from "./code.mapper";
import { imgMapper } from "./img.mapper";
import { tableMapper } from "./table.mapper";
import { hrMapper } from "./hr.mapper";
import {
  h1Mapper,
  h2Mapper,
  h3Mapper,
  h4Mapper,
  h5Mapper,
  h6Mapper,
  pMapper,
  spanMapper,
} from "./typography.mapper";

export const tagMappers = {
  a: aMapper,
  table: tableMapper,
  img: imgMapper,
  code: codeMapper,
  h1: h1Mapper,
  h2: h2Mapper,
  h3: h3Mapper,
  h4: h4Mapper,
  h5: h5Mapper,
  h6: h6Mapper,
  p: pMapper,
  span: spanMapper,
  hr: hrMapper,
};
